'use client';

import { useIntl } from 'react-intl';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { type PriceCurrency } from '@packages/gql/generated/shopping/graphql';
import { ArticleServicesFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesFragmentFragmentDoc';
import { articleServicesMessages } from './messages';
import { ArticleServicesCluster } from './ArticleServicesCluster/ArticleServicesCluster';
import { BadgeDV } from '../BadgeDV/BadgeDV';

/* GraphQL */ `
  fragment ArticleServicesFragment on APlus {
    clusters {
      ...ArticleServicesClusterFragment
    }
  }
`;

export type ArticleServicesProps = {
  data: FragmentType<typeof ArticleServicesFragmentFragmentDoc>;
  /* should be in aPlus price value */
  currency: PriceCurrency;
};

export const ArticleServices = ({ data, currency }: ArticleServicesProps) => {
  const { clusters } = getFragmentData(ArticleServicesFragmentFragmentDoc, data);

  const { formatMessage } = useIntl();

  if (clusters.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader hasDivider>
        <div>
          <BadgeDV>{formatMessage(articleServicesMessages.articleServicesCardTip)}</BadgeDV>
          <span className="text-size-headline-base pl-2">
            {formatMessage(articleServicesMessages.articleServicesCardHeadline)}
          </span>
        </div>
      </CardHeader>
      <CardContent className="pb-2">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {clusters.map(
            (cluster, idx) =>
              cluster && (
                <ArticleServicesCluster
                  data={cluster}
                  currency={currency}
                  key={JSON.stringify(cluster)}
                  isLastCluster={clusters.length - 1 === idx}
                />
              ),
          )}
        </form>
      </CardContent>
    </Card>
  );
};
